import React, { useEffect } from 'react'
import Layout from '../../Components/Layout/Layout'
import HistoryUi from './HistoryUi'
import { useGetHistoryQuery } from '../../store/Api/history'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { hidetoast } from '../../Utils/function'

const History = () => {
    const location = useLocation();
    const auditId = location?.state?.data?.id;
    const {data: historyData,isLoading} = useGetHistoryQuery({auditId});
    // const historyData = {
    //     question_1: {
    //         question: "How are you?",
    //         user_answer: ["Yes", "Fine"],
    //         history: [
    //             {
    //                 question: "Kem Party",
    //                 user_answer: ["Bas"]
    //             }
    //         ]
    //     },
    //     question_2: {
    //         question: "What is your favorite color?",
    //         user_answer: ["Blue"],
    //         history: [
    //             {
    //                 question: "What is your favorite color?",
    //                 user_answer: ["Red"]
    //             }
    //         ]
    //     },
    //     question_3: {
    //         question: "What is Color?",
    //         // user_answer: ["Blue"],
    //         history: [],
    //         sub_question:{
    //             sub_question_1: {
    //                 question: "How are you?",
    //                 user_answer: ["Yes", "Fine"],
    //                 history: [
    //                     {
    //                         question: "Kem Party",
    //                         user_answer: ["Bas"]
    //                     }
    //                 ]
    //             }
    //         }
    //     },
    // };
    
    const dispatch = useDispatch();
    const toast = useSelector((state) => state.toast);

    // Auto-hide toast after 3 seconds
   useEffect(() => {
      if (toast.message) {
         hidetoast()
      }
    }, [toast.message, dispatch]);

    
  return (
    <Layout>
        <HistoryUi
            toast={toast}
            historyData={historyData?.data}
        
        />
    </Layout>
  )
}

export default History
